var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 16.0762C5.31065 16.3825 2 17.5752 2 19C2 20.6569 6.47715 22 12 22C17.5228 22 22 20.6569 22 19C22 17.5752 18.6893 16.3825 14.25 16.0762V18C14.25 19.2426 13.2426 20.25 12 20.25C10.7574 20.25 9.75 19.2426 9.75 18V16.0762Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V18C11.25 18.4142 11.5858 18.75 12 18.75C12.4142 18.75 12.75 18.4142 12.75 18V12.625L21.2111 8.39443C21.9482 8.0259 21.9482 6.9741 21.2111 6.60557L12.75 2.375V2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCorner);
export default __webpack_public_path__ + "static/media/flag-corner.6046ff3d9df55c7917abdbd1729f1d84.svg";
export { ForwardRef as ReactComponent };